import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS } from '../types/application';
import { CursorDirection } from '../../utils/constant';

export type ParamsProps = {
  page: number;
  search: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
  amcApproverStatus: string;
  isSTPApplicable: string;
  applicationSentBack: boolean | null;
  kycModified: string;
  sortDirection: string;
  rowsPerPage: number;
  nextCursor: string;
  prevCursor: string;
  cursorDirection: CursorDirection;
  hasNext: boolean;
  hasPrev: boolean;
  currentCursor: string;
  paginationRole: string;
};

export const initialState: ParamsProps = {
  page: 1,
  applicationType: '',
  status: '',
  search: '',
  modeOfHolding: '',
  distributorId: '',
  isSTPApplicable: '',
  amcApproverStatus: '',
  applicationSentBack: null,
  kycModified: '',
  sortDirection: '',
  rowsPerPage: 10,
  nextCursor: '',
  prevCursor: '',
  cursorDirection: CursorDirection.NEXT,
  hasNext: false,
  hasPrev: false,
  currentCursor: '',
  paginationRole: '',
};

function paramsReducer(state = initialState, action: AnyAction): Partial<ParamsProps> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      return {
        ...state,
        status:
          action.body.role === 'amcapprover'
            ? 'sent_to_amc_approver'
            : action.body.role === 'poaapprover'
            ? 'sent_to_poa_approver'
            : '',
      };
    }
    case 'GET_PARAMS_DATA':
      return {
        ...state,
        page: action.paramsObj.page,
        applicationType: action.paramsObj.applicationType,
        status: action.paramsObj.status,
        modeOfHolding: action.paramsObj.modeOfHolding,
        distributorId: action.paramsObj.distributorId,
        isSTPApplicable: action.paramsObj.isSTPApplicable,
        search: action.paramsObj.search,
        amcApproverStatus: action.paramsObj.amcApproverStatus,
        applicationSentBack: action.paramsObj.applicationSentBack,
        kycModified: action.paramsObj.kycModified,
        sortDirection: action.paramsObj.order,
        rowsPerPage: action.paramsObj.limit,
        nextCursor: action.paramsObj.nextCursor,
        prevCursor: action.paramsObj.prevCursor,
        cursorDirection: action.paramsObj.direction,
        hasNext: action.paramsObj.hasNext,
        hasPrev: action.paramsObj.hasPrev,
        currentCursor: action.paramsObj.cursor,
        paginationRole: action.paramsObj.paginationRole || '',
      };
    case CREATE_APPLICATION_SUCCESS:
    case LOGOUT_SUCCESS: {
      return { ...initialState };
    }
    default:
      return state;
  }
}

export default paramsReducer;
